import { render, staticRenderFns } from "./StickyHeaderSection.vue?vue&type=template&id=2645863a&"
import script from "./StickyHeaderSection.vue?vue&type=script&lang=js&"
export * from "./StickyHeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeaderSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports